<template>
  <div class="base">
    <main-header page_type="my_center" />
    <div class="info">
      <div class="personal">
        <a-row class="base-info" :gutter="8">
          <a-col :span="5" class="head-portrait">
            <div @click="goProfile()">
              <img :src="userInfo.avatar" alt="">
            </div>
            <div class="label">
              <span>家长</span>
            </div>
          </a-col>
          <a-col :span="15" class="name-login-area">
            <div class="name-area">
              <span class="name">{{ userInfo.nick_name }}</span>
              <span v-if="userInfo.auth_status" class="icon">
                <a-icon type="safety-certificate" theme="filled" style="color: #d7b680;" />
              </span>
              <span v-else style="margin-left: 10px;">
                <router-link :to="{ name: 'UserSettingRealname' }">去实名</router-link>
              </span>
            </div>
            <div class="last-login">
              <span>上次登录时间</span>
              <span style="margin-left: 10px">{{ userInfo.last_login_time | timeFormat }}</span>
            </div>
          </a-col>
          <a-col :span="4" class="setting-notice">
            <span class="setting" @click="goSetting">
              <a-icon type="setting" />
            </span>
            <span class="notice" @click="goNotice">
              <a-icon type="bell" />
            </span>
          </a-col>
        </a-row>
      </div>
      <div class="order-data">
        <div class="item" @click="goOrder('Pending')">
          <div>
            <a-badge :count="orderStatusGroup.Unpaid">
              <a-icon class="icon" type="folder-open" />
            </a-badge>
          </div>
          <div class="title">
            待支付
          </div>
        </div>
        <div class="item" @click="goOrder('Active')">
          <div>
            <a-badge :count="orderStatusGroup.Active">
              <a-icon class="icon" type="reload" />
            </a-badge>
          </div>
          <div class="title">
            进行中
          </div>
        </div>
        <div class="item" @click="goOrder('Cancelling')">
          <div>
            <a-badge :count="orderStatusGroup.Cancelling">
              <a-icon class="icon" type="transaction" />
            </a-badge>
          </div>
          <div class="title">
            取消中
          </div>
        </div>
        <div class="item" @click="goOrder('Complete')">
          <div>
            <a-badge :count="orderStatusGroup.Complete">
              <a-icon class="icon" type="file-done" />
            </a-badge>
          </div>
          <div class="title">
            已完成
          </div>
        </div>
        <div class="item" @click="goOrder('all')">
          <div>
            <a-badge :count="orderStatusGroup.all">
              <a-icon class="icon" type="ellipsis" />
            </a-badge>
          </div>
          <div class="title">
            全部
          </div>
        </div>
      </div>
      <!-- 我的孩子 -->
      <div class="children-area">
        <div class="title-area">
          <span class="title left">我的孩子</span>
          <span class="right">
            <a-icon type="right" @click="goChild" />
          </span>
        </div>
        <a-empty v-if="studentList.length == 0 && !loading" />
        <div v-else class="list">
          <div v-for="(student, index) in studentList.slice(0, 2)" :key="index" class="item">
            <a-row :gutter="8">
              <a-col class="head-img" :span="6">
                <img src="@/assets/test-header.png" alt="" @click="gotoEditChild(student.id)">
              </a-col>
              <a-col class="student-info" :span="10">
                <div class="name" @click="gotoEditChild(student.id)">
                  {{ student.nick_name }}
                </div>
                <div class="grader">
                  {{ student.stage }}
                </div>
              </a-col>
              <a-col class="show-button" :span="8">
                <a-button type="ghost" @click="showStudentCourse(student.id)">
                  查看课程
                </a-button>
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="other">
        <!-- 工单，帮助中心列表 -->
        <div class="function-list">
          <div class="item" @click="goCollection">
            <span class="icon">
              <a-icon type="star" />
            </span>
            <span class="name">我的收藏</span>
            <span class="right">
              <a-icon type="right" />
            </span>
          </div>
          <div class="item" @click="goTicket">
            <span class="icon">
              <a-icon type="exception" />
            </span>
            <span class="name">我的工单</span>
            <span class="right">
              <a-icon type="right" />
            </span>
          </div>
          <div class="item" @click="goHelps">
            <span class="icon">
              <a-icon type="question-circle" />
            </span>
            <span class="name">帮助中心</span>
            <span class="right">
              <a-icon type="right" />
            </span>
          </div>
          <div class="item" @click="goPromotion">
            <span class="icon">
              <a-icon type="security-scan" />
            </span>
            <span class="name">我要推广</span>
            <span class="right">
              <a-icon type="right" />
            </span>
          </div>
          <div class="item" @click="goArticle">
            <span class="icon">
              <a-icon type="profile" />
            </span>
            <span class="name">我的文章</span>
            <span class="right">
              <a-icon type="right" />
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- 下一个 -->
  </div>
</template>
<script>
import { MainHeader } from '@/components'

export default {
  name: 'Moment',
  components: {
    MainHeader
  },
  data() {
    return {
      loading: true,
      orderStatusGroup: {},
      studentList: [],
      userInfo: {}
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$http({
        url: '/index/user/wapIndex',
        method: 'get'
      }).then(res => {
        this.loading = false
        if (res.status === 'success') {
          var data = res.data
          this.orderStatusGroup = data.order_status_group
          this.studentList = data.student_list
          this.userInfo = data.user_info
        } else {
          this.$notification.error({
            message: '系统繁忙，请刷新重试',
            description: ''
          })
        }
      })
    },
    showStudentCourse(studentId) {
      console.log(studentId)
      this.$router.push({ name: 'UserCourseArrangement', params: { id: studentId } })
    },
    // 去设置
    goSetting() {
      this.$router.push({ name: 'UserSetting' })
    },
    // 通知
    goNotice() {

    },
    goOrder(orderStatus) {
      this.$router.push({ name: 'UserOrder', query: { status: orderStatus } })
    },
    //  收藏
    goCollection() {
      this.$router.push({ name: 'UserCollection' })
    },
    // 去工单
    goTicket() {
      this.$router.push({ name: 'UserWorkOrder' })
    },
    // 去帮助中心
    goHelps() {
      this.$router.push({ name: 'Help' })
    },
    // 去安全中心
    goPromotion() {
      this.$router.push({ name: 'UserPromotion' })
    },
    // 我的文章
    goArticle() {
      this.$router.push({ name: 'UserMyArticle' })
    },
    goTutor() {
      console.log(1)
    },
    gotoEditChild(id) {
      this.$router.push({ name: 'UserAddChild', params: { id: id } })
    },
    goChild() {
      this.$router.push({ name: 'UserStudents' })
    },
    goProfile() {
      this.$router.push({ name: 'UserProfile' })
    }
  }
}
</script>
<style lang="stylus">
  .base {
      min-width: 280px;
      max-width: 420px;
      margin: auto;
      background-color: #fff;
  }

  .container {
  }

  .info {
    background-color: #f6f6f6;
    padding: 15px;

    .personal {

      .base-info {
        margin-top: 10px;

        .head-portrait {
          text-align: center;

          img {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            border: solid 1px #ffffff;
          }

          .label {
            span {
              display: inline-block;
              padding: 3px 7px 2px 7px;
              background-color: #fa750d;
              border-radius: 5px;
              opacity: 0.5;
              color: #fff;

              font-size: 10px;

              position: relative;
              top: -10px;
            }
          }
        }

        .name-login-area {

          .name-area {
            height: 32px;
            line-height: 32px;

            .name {
              font-family: PingFang-SC-Bold;
              font-size: 18px;
              line-height: 21px;
              letter-spacing: 0px;
              color: #333333;
              font-weight: bold;
            }

            .icon {
              margin-left: 10px;
            }
          }

          .last-login {
            font-family: PingFang-SC-Regular;
            font-size: 12px;
            line-height: 32px;
            letter-spacing: 0px;
            color: #999999;
          }
        }

        .setting-notice {
          text-align: right;
          font-size: 18px;

          span:nth-child(1) {
            margin-right: 10px;
          }
        }
      }
    }

    .order-data {
      height: 80px;
      background-color: #ffffff;
      border-radius: 10px;
      width: 100%;
      overflow: hidden;
      padding: 15px;
      margin-top: 5px;
      box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);

      .item {
        width: 20%;
        float: left;
        text-align: center;

        .icon {
          font-size: 18px;
        }

        .title {
          font-size: 12px;
        }
      }
    }
  }

  .other {
    padding: 0px 15px 15px 15px;
    background-color: #fff;
  }

  // 学员
  .children-area {
    padding: 24px 15px;
    background-color: #fff;
    margin-top:15px;
    border-radius: 10px;
    box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);

    .title-area {
      overflow: hidden;

      .left {
        float: left;
        font-family: PingFang-SC-Bold;
        font-size: 16px;
        line-height: 28px;
        letter-spacing: 0px;
        color: #333333;
      }

      .right {
        float: right;
        font-size: 16px;
        color: #999;
      }
    }

    .list {
      margin-top: 20px;

      .item {
        padding: 15px;
        background-color: #ffeee5;
        border-radius: 10px;
        margin-bottom: 10px;

        .head-img {

          img {
            width: 60px;
            height: 60px;
            border-radius: 50%;
          }
        }

        .student-info {

          .name {
            font-family: PingFang-SC-Bold;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 24px;
            letter-spacing: 0px;
            color: #333333;
            font-weight: bold;
          }

          .grader {
            font-family: PingFang-SC-Medium;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 32px;
            letter-spacing: 0px;
            color: #666666;
          }

        }

        .show-button {
          line-height: 60px;

          button {
            width: 90px;
            height: 33px;
            border-radius: 17px;
            border: solid 1px #999999;
            color: #666;
          }
        }
      }

    }

  }

  .function-list {
    padding: 20px 15px;

    .item {
      overflow: hidden;
      margin-bottom: 20px;

      .icon {
        float: left;
        color: #b9b9b9;
      }

      .name {
        float: left;
        font-family: PingFang-SC-Medium;
        font-size: 14px;
        letter-spacing: 0px;
        color: #666666;

        margin-left: 15px;
      }

      .right {
        float: right;
        color: #999;
      }

    }
  }
</style>
